// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';

// utilities
import _ from 'lodash';
import cx from 'classnames';

// components
import SimpleFileInput, { RetrievalButton } from '../../../common/components/c_SourceSimpleFileInput';
import ModalX from '../../../common/svgs/ModalX';
import FlatButton from '../../../common/components/c_FlatButton';
import TextField from '../../../common/components/c_TextField';

@connect((state, props) => {
  return {
    documents: state.documents,
    pathname: state.routing.locationBeforeTransitions.pathname
  };
})

export default class AssessmentsView extends Component {
  static propTypes = {
    applicant: PropTypes.object,
    documents: PropTypes.object,
    stateToggle: PropTypes.func,
    staticData: PropTypes.object,
    open: PropTypes.bool,
    pathname: PropTypes.string
  }

  constructor(props) {
    super();

    this.flipBack = props.stateToggle.bind(this, 'edit', 0);

    // increment through alphabet
    let inc = 65; // charcode for 'A'
    this.getIncrementedChar = () => String.fromCharCode(inc++);
  }

  mapObject(object, callback) {
    return Object.keys(object).map(function (key) {
      return callback(object[key], key);
    });
  }

  downladAll() {
    const links = document.getElementsByClassName('retrieval-button file-get document-file');
    for (let i=0; i < links.length; i++) {
      links[i].click();
    }
  }

  render() {
    return (
      <div className='document-card' 
        data-id={`${this.props.applicant.user.email} document`}
        key={`Documents Card ${this.props.applicant.profile.id}`}
        style={this.props.style}>
        <ModalX onClick={this.flipBack}/>
        <div className='top-wrapper clearfix'>
          <div className='title'>Available Documents</div>
        </div>
        <div className='body-wrapper'>
          {
            !_.isEmpty(this.props.documents)
            &&
            <div className='documents-container'>
            {
              this.mapObject(this.props.documents, (document, key) =>
                <div className='document-item' data-id={`${document.fileTypeName}-${key}`}>
                  <TextField className='type-name'
                    defaultValue={document.fileTypeName}
                    disabled={true}
                    inputStyle={{
                      textOverflow: 'ellipsis'
                    }}
                    />
                    <RetrievalButton
                      className='file-get document-file'
                      loadingClass=''
                      notLoadingClass=''
                      failureClass=''
                      autoLoad
                      noMessage
                      path={document.storagePath}
                      signingRoute='/api/s3/get-sign'
                    >
                      <TextField
                        disabled
                        value={document.fileName}
                        inputStyle={{
                          textOverflow: 'ellipsis'
                        }}
                      />
                      <span className='megabyte-count'>
                        {`${Math.max(Math.round(document.fileSize/100000)/10, 0.1)} Mgb`}
                      </span>
                    </RetrievalButton>
                </div>
              )
            }
            </div>
          }
          {
            _.isEmpty(this.props.documents)
            &&
            <div className='no-documents'>No Documents Have Been Uploaded Yet</div>
          }
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/c_DocumentsCard/index.js